import React from 'react'
import { NavLink } from 'react-router-dom'
import { HeaderWrapper } from './HeaderWrapper'
import appClasses from 'App.module.scss'
import { useTranslation } from 'react-i18next'

export const Header = () => {
  const { t } = useTranslation()

  return (
    <HeaderWrapper logoHref="/" className={appClasses.header}>
      <nav className="wb-nav wb-nav--desktop wb-nav--main">
        <NavLink
          to="/bookings"
          exact
          activeClassName="wb-nav__control--active"
          className="wb-nav__control wb-nav__control--offset-left"
        >
          {t('components.header.header.overview')}
        </NavLink>
        <NavLink
          id="create-new-booking-e2e"
          to="/bookings/new"
          activeClassName="wb-nav__control--active"
          className="wb-nav__control wb-nav__control--offset-left"
        >
          {t('components.header.header.request')}
        </NavLink>
        <NavLink
          id="damage-new-report-e2e"
          to="/damage_reports/new"
          activeClassName="wb-nav__control--active"
          className="wb-nav__control wb-nav__control--offset-left"
        >
          {t('components.header.header.damage')}
        </NavLink>
        <NavLink
          id="inquiries-new-e2e"
          to="/inquiries/new"
          activeClassName="wb-nav__control--active"
          className="wb-nav__control wb-nav__control--offset-left"
        >
          {t('components.header.header.contact')}
        </NavLink>
      </nav>
    </HeaderWrapper>
  )
}
